import {
  Component,
  Input,
  OnInit
} from '@angular/core';

@Component({
  selector: 'axis-styled-list,[axis-styled-list]',
  templateUrl: './styled-list.component.html'
})
export class StyledListComponent implements OnInit {
  @Input() dataProvider: any;
  @Input() orderedList = false;
  @Input() listStyle = '';
  public wrapperClasses = '';

  ngOnInit() {
    if (this.listStyle) {
      switch (this.listStyle) {
        case 'timeline':
          this.wrapperClasses = 'axis-list-timeline'
          break;
        case 'cross':
          this.wrapperClasses = 'axis-list-cross'
          break;
        case 'timeline-dashed':
          this.wrapperClasses = 'axis-list-timeline dashed'
          break;
        case 'inline':
          this.wrapperClasses = 'axis-list-inline'
          break;
        case 'inline-pills':
          this.wrapperClasses = 'axis-list-inline axis-list-pills'
          break;
        case 'inline-arrow':
          this.wrapperClasses = 'axis-list-inline axis-list-arrow'
          break;
        case 'check':
          this.wrapperClasses = 'axis-list-check'
          break;
        case 'add':
          this.wrapperClasses = 'axis-list-add'
          break;
        default:
          break;
      }
    }
  }
}
